import { createContext } from 'react';

const FiltersContext = createContext();

const FiltersProvider = ({ children, fullWidth = false }) => {
    return <FiltersContext.Provider value={{ fullWidthFilter: fullWidth }}>{children}</FiltersContext.Provider>;
};

export { FiltersContext, FiltersProvider };
